// The poses (LoRAs) offered in the pose pickers: title, thumbnails, plan, categories and the
// models each is enabled for. Thumbnail rules: helpers/poseThumb.js.

export const loras = [
  {
    title: 'Default',
    src: '/assets/loras/random.webp',
    animeSrc: '/assets/loras/random.webp',
    plan: 'Free',
  },
  {
    title: 'POV Blowjob',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Free',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Cinematic XL',
      'Hardcore XL',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'POV Blowjob Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/flame/POV Blowjob Gay.webp',
    plan: 'Free',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'POV Doggystyle',
    plan: 'Free',
    src: '/assets/loras/XLposes/POV_Doggystyle.webp',
    animeSrc: '/assets/loras/animepovdoggy-648a50b39754d.webp',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Cinematic XL',
      'Hardcore XL',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'Handjob',
    plan: 'Free',
    src: '/assets/loras/XLposes/handjob.webp',
    animeSrc: '/assets/loras/animepovhj-648a50b397549.webp',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Cinematic XL',
      'Hardcore XL',
    ],
  },
  {
    title: 'Handjob Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/flame/Handjob Gay.webp',
    plan: 'Free',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Flashing Boobs',
    plan: 'Free',
    src: '/assets/loras/realflashing-648a50b9ad05a.webp',
    animeSrc: '/assets/loras/animeflashing-648a50b006850.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'Flashing Boobs Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Free',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Grab Ass',
    src: '/assets/loras/realgrab-648a50b98ecde.webp',
    animeSrc: '/assets/loras/animegrab-648a50b11bf36.webp',
    plan: 'Free',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'ButtGrab Lesbian',
    src: '/assets/loras/realgrab-648a50b98ecde.webp',
    animeSrc: '/assets/loras/animegrab-648a50b11bf36.webp',
    plan: 'Plus',
    categories: ['Lesbian'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Thigh Sex',
    animeSrc: '/assets/loras/animethigh-648a50b60f30b.webp',
    plan: 'Free',
    categories: ['Straight'],
    enabled: ['Anime XL', 'Anime', 'Hyperanime', 'Furtoon', 'Fur'],
  },
  {
    title: 'POV Anal',
    src: '/assets/loras/realanal-648a50b72975f.webp',
    animeSrc: '/assets/loras/animeanal-648a50ad89eab.webp',
    plan: 'Free',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'POV Anal Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Free',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'After Sex',
    animeSrc: '/assets/loras/animeaftersex-6492cf8634e4f.webp',
    plan: 'Free',
    categories: ['Straight', 'Lesbian'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Anime XL',
      'Anime',
      'Hyperanime',
      'Furtoon',
      'Fur',
    ],
  },
  {
    title: 'After Sex Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Free',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'After Sex Lesbian',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Free',
    categories: ['Lesbian'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Female Masturbation',
    src: '/assets/loras/realfingering-6492ce5f23d95.webp',
    animeSrc: '/assets/loras/animefingering-6492ce0ca0cdd.webp',
    plan: 'Free',
    categories: ['Straight', 'Lesbian'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'Female Masturbation Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Free',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Sideway Ass',
    animeSrc: '/assets/loras/animesideways-6492ce140a80a.webp',
    plan: 'Free',
    categories: ['Straight', 'Lesbian'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime XL',
      'Anime',
      'Hyperanime',
      'Furtoon',
      'Fur',
    ],
  },
  {
    title: 'Sideway Ass Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Free',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Spread Ass',
    animeSrc: '/assets/loras/animespreadass-6492ce1b2a43c.webp',
    plan: 'Free',
    categories: ['Straight', 'Lesbian'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Anime XL',
      'Anime',
      'Hyperanime',
      'Furtoon',
      'Fur',
    ],
  },
  {
    title: 'Spooning',
    src: '/assets/loras/realspooning-6492ce6693266.webp',
    animeSrc: '/assets/loras/animespooning-6492ce17bd858.webp',
    plan: 'Free',
    categories: ['Straight', 'Lesbian'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Furtoon',
      'Fur',
    ],
  },
  {
    title: 'Spooning Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Free',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'POV Missionary',
    src: '/assets/loras/XLposes/Missionary.webp',
    animeSrc: '/assets/loras/animemissionary-6492ce107d6bb.webp',
    plan: 'Free',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Cinematic XL',
      'Hardcore XL',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'POV Missionary Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Free',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'POV Missionary Lesbian',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Free',
    categories: ['Lesbian'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Solo Breast Grab',
    src: '/assets/loras/realsolobreast-6492ce62bac74.webp',
    animeSrc: '/assets/loras/animesolograb-6492ce1734b40.webp',
    plan: 'Free',
    categories: ['Straight', 'Lesbian'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'From Below',
    animeSrc: '/assets/loras/animeupskirt-6492ce227f048.webp',
    plan: 'Free',
    categories: ['Straight', 'Lesbian'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Anime XL',
      'Anime',
      'Hyperanime',
      'Furtoon',
      'Fur',
    ],
  },
  {
    title: 'From Below Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Free',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Resting On Stomach',
    src: '/assets/loras/realstomach-6492ce6a4b3b0.webp',
    animeSrc: '/assets/loras/animestomach-6492ce1e9f695.webp',
    plan: 'Free',
    categories: ['Straight', 'Lesbian'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'Resting On Stomach Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Free',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Shirt Pull',
    animeSrc: '/assets/loras/animeshirtpull-6492ce1364f56.webp',
    plan: 'Free',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime XL', 'Anime', 'Hyperanime', 'Furtoon', 'Fur'],
  },
  {
    title: 'Penis',
    thumbFromSrc: true,
    src: '/assets/loras/ponyGay/Penis.webp',
    animeSrc: '/assets/loras/ponyAnimeGay/Penis.webp',
    plan: 'Free',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Cinematic XL',
      'Hardcore XL',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'Breasts Pressed Against Glass',
    src: '/assets/loras/XLposes/Breasts Pressed Against Glass.webp',
    animeSrc: '/assets/loras/anime_breast_pressed_against_glass.webp',
    plan: 'Free',
    categories: ['Straight', 'Lesbian'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Cinematic XL',
      'Hardcore XL',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'Reverse Deepthroat',
    src: '/assets/loras/real_reverse_deepthroat.webp',
    plan: 'Free',
    categories: ['Straight'],
    enabled: ['Real', 'Hyperreal', 'K-Pop'],
  },
  {
    title: 'Orgy',
    src: '/assets/loras/XLposes/Orgy.webp',
    animeSrc: '/assets/loras/anime_foursome.webp',
    plan: 'Free',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Cinematic XL',
      'Hardcore XL',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'Orgy Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Free',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Orgy Lesbian',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/Orgy Lesbian.webp',
    plan: 'Free',
    categories: ['Lesbian'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Cinematic XL',
      'Hardcore XL',
    ],
  },
  {
    title: 'Lesbian Oral',
    animeSrc: '/assets/loras/lesbian_cunnulingus.webp',
    plan: 'Free',
    categories: ['Lesbian'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Anime XL',
      'Anime',
      'Hyperanime',
      'Furtoon',
      'Fur',
    ],
  },
  {
    title: 'Gay Grabbing',
    src: '/assets/loras/real_grab_pec.webp',
    animeSrc: '/assets/loras/gay_pecs.webp',
    plan: 'Free',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'BDSM Tape',
    src: '/assets/loras/real_tape_gag.webp',
    animeSrc: '/assets/loras/bondage_tape.webp',
    plan: 'Free',
    categories: ['Straight', 'Lesbian'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'BDSM Tape Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Free',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'BDSM Leash',
    src: '/assets/loras/real_on_leash.webp',
    animeSrc: '/assets/loras/on_a_leash.webp',
    plan: 'Free',
    categories: ['Straight', 'Lesbian'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'BDSM Leash Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Free',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Downblouse',
    src: '/assets/loras/XLposes/Downblowse.webp',
    animeSrc: '/assets/loras/anime_downblouse.webp',
    plan: 'Free',
    categories: ['Straight', 'Lesbian'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'Sitting',
    src: '/assets/loras/asssupport.webp',
    animeSrc: '/assets/loras/anime_asssupport.webp',
    plan: 'Free',
    categories: ['Straight', 'Lesbian'],
    enabled: [
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'Vagina',
    src: '/assets/loras/legsup.webp',
    animeSrc: '/assets/loras/anime_legsup.webp',
    plan: 'Free',
    categories: ['Straight', 'Lesbian'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'Cuddling',
    animeSrc: '/assets/loras/anime_cuddling.webp',
    plan: 'Free',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Anime XL',
      'Anime',
      'Hyperanime',
      'Furtoon',
      'Fur',
    ],
  },
  {
    title: 'Lesbian Cuddling',
    animeSrc: '/assets/loras/anime_cuddling_lesbian.webp',
    plan: 'Free',
    categories: ['Lesbian'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Anime XL',
      'Anime',
      'Hyperanime',
      'Furtoon',
      'Fur',
    ],
  },
  {
    title: 'Gay Cuddling',
    animeSrc: '/assets/loras/anime_cuddling_gay.webp',
    plan: 'Free',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Anime XL',
      'Anime',
      'Hyperanime',
      'Furtoon',
      'Fur',
    ],
  },
  {
    title: 'Feet',
    src: '/assets/loras/flame/Feet.webp',
    animeSrc: '/assets/loras/anime_feet.webp',
    plan: 'Free',
    categories: ['Straight', 'Lesbian'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Anime XL',
      'Anime',
      'Hyperanime',
      'Furtoon',
      'Fur',
    ],
  },
  {
    title: 'Feet Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/Feet Gay.webp',
    plan: 'Free',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Cinematic XL',
      'Hardcore XL',
    ],
  },
  {
    title: 'Vagina Spread',
    src: '/assets/loras/realspread-6492ce667f634.webp',
    animeSrc: '/assets/loras/animespread-6492ce1aa7573.webp',
    plan: 'Plus',
    categories: ['Straight', 'Lesbian'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'Vagina Spread Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Plus',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Jacko Pose',
    animeSrc: '/assets/loras/animejacko-6492ce101ff32.webp',
    plan: 'Plus',
    categories: ['Straight', 'Lesbian'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime XL',
      'Anime',
      'Hyperanime',
      'Furtoon',
      'Fur',
    ],
  },
  {
    title: 'Jacko Pose Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Plus',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Titjob Real',
    src: '/assets/loras/XLposes/Titjob.webp',
    plan: 'Plus',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Cinematic XL',
      'Hardcore XL',
      'Real',
      'Hyperreal',
      'K-Pop',
    ],
  },
  {
    title: 'Titjob Anime',
    animeSrc: '/assets/loras/animetitjob-6492ce1ecc71f.webp',
    plan: 'Plus',
    categories: ['Straight'],
    enabled: ['Anime XL', 'Anime', 'Hyperanime', 'Furtoon', 'Fur'],
  },
  {
    title: 'Bukkake',
    src: '/assets/loras/realbukakke-6492ce5b747cf.webp',
    animeSrc: '/assets/loras/animebukkake-6492ce08b94bd.webp',
    plan: 'Plus',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Anime XL',
      'Anime',
      'Hyperanime',
      'Furtoon',
      'Fur',
    ],
  },
  {
    title: 'Bukkake Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Plus',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Amazon Position',
    src: '/assets/loras/realamazon-6492ce5b6cb19.webp',
    animeSrc: '/assets/loras/animeamazon-6492ce088da35.webp',
    plan: 'Plus',
    categories: ['Straight'],
    enabled: [
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'Cheek Bulge Blowjob',
    src: '/assets/loras/realcheek-6492ce5ec2ca3.webp',
    animeSrc: '/assets/loras/animecheek-6492ce0ccf255.webp',
    plan: 'Plus',
    categories: ['Straight'],
    enabled: [
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'Blowjob Under Desk',
    src: '/assets/loras/realunderdesk-6492ce6dda6e3.webp',
    animeSrc: '/assets/loras/animeunderdesk-6492ce227ee72.webp',
    plan: 'Plus',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'Blowjob Under Desk Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Plus',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Cum in Mouth',
    animeSrc: '/assets/loras/animecummouth-648a50afd2c5d.webp',
    plan: 'Plus',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Anime XL',
      'Anime',
      'Hyperanime',
      'Furtoon',
      'Fur',
    ],
  },
  {
    title: 'Cum in Mouth Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Plus',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Front View Cowgirl',
    src: '/assets/loras/realbehind-648a50b899da5.webp',
    animeSrc: '/assets/loras/animebehind-648a50ad922ae.webp',
    plan: 'Plus',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Anime XL',
      'Anime',
      'Hyperanime',
      'Furtoon',
      'Fur',
    ],
  },
  {
    title: 'Front View Cowgirl Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Plus',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Front View Cowgirl Lesbian',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Plus',
    categories: ['Lesbian'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'ButtJob',
    animeSrc: '/assets/loras/ponyAnime/ButtJob.webp',
    plan: 'Plus',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime XL',
      'Anime',
      'Hyperanime',
      'Furtoon',
      'Fur',
    ],
  },
  {
    title: 'ButtJob Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Plus',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'POV Spitroast',
    src: '/assets/loras/realpovroast-648a50bbf1d91.webp',
    animeSrc: '/assets/loras/animeroast-648a50b60810c.webp',
    plan: 'Plus',
    categories: ['Straight'],
    enabled: [
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'POV Threesome BlowJob',
    animeSrc: '/assets/loras/animepovthree-648a50b4ba621.webp',
    plan: 'Plus',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Anime',
      'Hyperanime',
      'Furtoon',
      'Fur',
    ],
  },
  {
    title: 'POV Threesome BlowJob Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Plus',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'POV Threesome Lesbian',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Plus',
    categories: ['Lesbian'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'POV Reverse Cowgirl',
    src: '/assets/loras/XLposes/POV_Reverse_Cowgirl.webp',
    animeSrc: '/assets/loras/animereversecow-648a50b4d6482.webp',
    plan: 'Plus',
    categories: ['Straight'],
    enabled: [
      'Cinematic XL',
      'Hardcore XL',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'Mating Press',
    animeSrc: '/assets/loras/animemating-648a50b1307a8.webp',
    plan: 'Plus',
    categories: ['Straight'],
    enabled: ['Anime', 'Hyperanime', 'Furtoon', 'Fur'],
  },
  {
    title: 'Piledrive',
    animeSrc: '/assets/loras/animepile-648a50b26125f.webp',
    plan: 'Plus',
    categories: ['Straight'],
    enabled: ['Anime', 'Hyperanime', 'Furtoon', 'Fur'],
  },
  {
    title: 'Lesbian Fingering',
    animeSrc: '/assets/loras/lesbian_fingering.webp',
    plan: 'Plus',
    categories: ['Lesbian'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Anime XL',
      'Anime',
      'Hyperanime',
      'Furtoon',
      'Fur',
    ],
  },
  {
    title: 'Lesbian Scissoring',
    animeSrc: '/assets/loras/lesbian_scissoring_option.webp',
    plan: 'Pro',
    categories: ['Lesbian'],
    enabled: ['Anime XL', 'Anime', 'Hyperanime', 'Furtoon', 'Fur'],
  },
  {
    title: 'Gay Cowboy Anime',
    animeSrc: '/assets/loras/gay_cowboy.webp',
    plan: 'Plus',
    categories: ['Gay'],
    enabled: ['Anime XL', 'Anime', 'Hyperanime', 'Furtoon', 'Fur'],
  },
  {
    title: 'Showering',
    src: '/assets/loras/shower.webp',
    animeSrc: '/assets/loras/anime_showering.webp',
    plan: 'Plus',
    categories: ['Straight', 'Lesbian'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'Showering Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Plus',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Gay Cowboy Real',
    src: '/assets/loras/real_gay_cowboy.webp',
    plan: 'Plus',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Real',
      'Hyperreal',
      'K-Pop',
    ],
  },
  {
    title: 'BDSM Tied Up',
    src: '/assets/loras/XLposes/BDSM_tied_up.webp',
    animeSrc: '/assets/loras/bondage_tied up.webp',
    plan: 'Plus',
    categories: ['Straight', 'Lesbian'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Cinematic XL',
      'Hardcore XL',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'BDSM Tied Up Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/flame/BDSM Tied Up Gay.webp',
    plan: 'Plus',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Cinematic XL',
      'Hardcore XL',
    ],
  },
  {
    title: 'Cum on Ass',
    src: '/assets/loras/real_cum_on_ass.webp',
    animeSrc: '/assets/loras/anime_cum_on_ass.webp',
    plan: 'Premium',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'Cum on Ass Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Premium',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Cumshot',
    src: '/assets/loras/XLposes/Cumshot.webp',
    animeSrc: '/assets/loras/anime_cumshot.webp',
    plan: 'Premium',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Cinematic XL',
      'Hardcore XL',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'Cumshot Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/flame/Cumshot Gay.webp',
    plan: 'Premium',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Ass On Glass',
    src: '/assets/loras/real_ass_on_glass.webp',
    animeSrc: '/assets/loras/anime_ass_on_glass.webp',
    plan: 'Premium',
    categories: ['Straight', 'Lesbian'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'Ass On Glass Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Premium',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Multiple Hands',
    src: '/assets/loras/real_multiple_hands.webp',
    animeSrc: '/assets/loras/anime_multiple_hands.webp',
    plan: 'Premium',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'Multiple Hands Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Premium',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Facesitting',
    animeSrc: '/assets/loras/anime_face_sitting.webp',
    plan: 'Premium',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime XL',
      'Anime',
      'Hyperanime',
      'Furtoon',
      'Fur',
    ],
  },
  {
    title: 'Facesitting Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Premium',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'On Off',
    src: '/assets/loras/real_onoff.webp',
    animeSrc: '/assets/loras/anime_on_off.webp',
    plan: 'Premium',
    categories: ['Straight', 'Lesbian'],
    enabled: [
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'Side Blowjob',
    animeSrc: '/assets/loras/anime_side_blowjob.webp',
    plan: 'Premium',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Anime XL',
      'Anime',
      'Hyperanime',
      'Furtoon',
      'Fur',
    ],
  },
  {
    title: 'Side Blowjob Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Premium',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Kneeling',
    src: '/assets/loras/real_headfuck_from_behind.webp',
    animeSrc: '/assets/loras/anime_headfuck_from_behind.webp',
    plan: 'Premium',
    categories: ['Straight'],
    enabled: [
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'BDSM Ballgag',
    src: '/assets/loras/real_ball_gag.webp',
    animeSrc: '/assets/loras/bondage_ballgag.webp',
    plan: 'Premium',
    categories: ['Straight', 'Lesbian'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'BDSM Ballgag Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Premium',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'POV Cowgirl',
    src: '/assets/loras/squat.webp',
    animeSrc: '/assets/loras/anime_squat.webp',
    plan: 'Premium',
    categories: ['Straight'],
    // Cinematic Flame since 2026-10-02, when the pose got its own `append_flame` text
    // (8/8 seeds in a bake-off). Not Anime Flame or Pony XL 2: untested there.
    enabled: [
      'Cinematic Flame',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'Giant',
    animeSrc: '/assets/loras/anime_giant.webp',
    plan: 'Premium',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime XL', 'Anime', 'Hyperanime', 'Furtoon', 'Fur'],
  },
  {
    title: 'POV Breast Grab',
    src: '/assets/loras/flame/POV Breast Grab.webp',
    animeSrc: '/assets/loras/anime_POV_breast_grab.webp',
    plan: 'Pro',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Anime XL',
      'Anime',
      'Hyperanime',
      'Furtoon',
      'Fur',
    ],
  },
  {
    title: 'POV Breast Grab Lesbian',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Pro',
    categories: ['Lesbian'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Surrounded by Penises',
    animeSrc: '/assets/loras/anime_surrounded_by_penises.webp',
    plan: 'Pro',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Anime XL',
      'Anime',
      'Hyperanime',
      'Furtoon',
      'Fur',
    ],
  },
  {
    title: 'Flashing In Public',
    src: '/assets/loras/real_flashing.webp',
    plan: 'Pro',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Real', 'Hyperreal', 'K-Pop'],
  },
  {
    title: 'Wet Tshirt',
    src: '/assets/loras/real_wet_tshirt.webp',
    animeSrc: '/assets/loras/anime_wet_tshirt.webp',
    plan: 'Pro',
    categories: ['Straight', 'Lesbian'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'Wet Tshirt Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Pro',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'BDSM Suspension',
    src: '/assets/loras/real_bondage_suspension.webp',
    animeSrc: '/assets/loras/bondage_suspension.webp',
    plan: 'Pro',
    categories: ['Straight', 'Lesbian'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'BDSM Suspension Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Pro',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Cum Bath',
    animeSrc: '/assets/loras/anime_cumbath.webp',
    plan: 'Pro',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Anime XL',
      'Anime',
      'Hyperanime',
      'Furtoon',
      'Fur',
    ],
  },
  {
    title: 'Cum Bath Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Pro',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Mooning',
    src: '/assets/loras/XLposes/mooning.webp',
    animeSrc: '/assets/loras/anime_pulling_down_pants.webp',
    plan: 'Pro',
    categories: ['Straight', 'Lesbian'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Cinematic XL',
      'Hardcore XL',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'Mooning Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/Mooning Gay.webp',
    plan: 'Pro',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Cinematic XL',
      'Hardcore XL',
    ],
  },
  {
    title: 'Multiple Mooning',
    animeSrc: '/assets/loras/anime_multipleass.webp',
    plan: 'Pro',
    categories: ['Straight', 'Lesbian'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Anime XL',
      'Anime',
      'Hyperanime',
      'Furtoon',
      'Fur',
    ],
  },
  {
    title: 'Multiple Mooning Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Pro',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
    ],
  },
  {
    title: 'Side Blowjob Real',
    src: '/assets/loras/real_side_blowjob.webp',
    plan: 'Pro',
    categories: ['Straight'],
    enabled: ['Real', 'Hyperreal', 'K-Pop'],
  },
  {
    title: 'Sucking Nipple',
    animeSrc: '/assets/loras/anime_sucking_nipple.webp',
    plan: 'Pro',
    categories: ['Straight'],
    enabled: ['Anime XL', 'Anime', 'Hyperanime', 'Furtoon', 'Fur'],
  },
  {
    title: 'Finger Sucking',
    animeSrc: '/assets/loras/anime_sucking_finger.webp',
    plan: 'Pro',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Anime XL',
      'Anime',
      'Hyperanime',
      'Furtoon',
      'Fur',
    ],
  },
  {
    title: 'Finger Sucking Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Pro',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Showing off Ass',
    src: '/assets/loras/real_showing_ass.webp',
    animeSrc: '/assets/loras/anime_showing_ass.webp',
    plan: 'Pro',
    categories: ['Straight', 'Lesbian'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'Showing off Ass Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Pro',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Reverse Blowjob',
    src: '/assets/loras/real_reverse_blowjob.webp',
    plan: 'Pro',
    categories: ['Straight'],
    enabled: ['Real', 'Hyperreal', 'K-Pop'],
  },
  {
    title: 'Lying Down Feet',
    src: '/assets/loras/XLposes/Showing_feet.webp',
    plan: 'Pro',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Real', 'Hyperreal', 'K-Pop'],
  },
  {
    title: 'Footjob',
    src: '/assets/loras/real_footjob.webp',
    plan: 'Pro',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Real',
      'Hyperreal',
      'K-Pop',
    ],
  },
  {
    title: 'Footjob Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Pro',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Dildo',
    src: '/assets/loras/real_dildo.webp',
    animeSrc: '/assets/loras/anime_dildo.webp',
    plan: 'Pro',
    categories: ['Straight', 'Lesbian'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'Dildo Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Pro',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Handbra/Holding Boobs',
    src: '/assets/loras/real-handbra.webp',
    animeSrc: '/assets/loras/anime_hand_bra.webp',
    plan: 'Pro',
    categories: ['Straight', 'Lesbian'],
    enabled: [
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'Milking Machine',
    src: '/assets/loras/real-milking.webp',
    animeSrc: '/assets/loras/anime_milking.webp',
    plan: 'Pro',
    categories: ['Straight', 'Lesbian'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'Panties Off',
    src: '/assets/loras/real-panties-up.webp',
    plan: 'Pro',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Real', 'Hyperreal', 'K-Pop'],
  },
  {
    title: 'Double Handjob',
    src: '/assets/loras/real-double-handjob.webp',
    animeSrc: '/assets/loras/anime_double_handjob.webp',
    plan: 'Pro',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'Double Handjob Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Pro',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Changing',
    src: '/assets/loras/pony/Changing.webp',
    animeSrc: '/assets/loras/ponyAnime/Changing.webp',
    plan: 'Pro',
    categories: ['Straight', 'Lesbian'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Cinematic XL',
      'Hardcore XL',
      'Anime XL',
      'Anime',
      'Hyperanime',
      'Furtoon',
      'Fur',
    ],
  },
  {
    title: 'Changing Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/Changing Gay.webp',
    plan: 'Pro',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Cinematic XL',
      'Hardcore XL',
    ],
  },
  {
    title: 'Bubble Bath',
    src: '/assets/loras/XLposes/Bubble_Bath.webp',
    animeSrc: '/assets/loras/anime_bubble_bath.webp',
    plan: 'Pro',
    categories: ['Straight', 'Lesbian'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Cinematic XL',
      'Hardcore XL',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'Bubble Bath Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/Bubble Bath Gay.webp',
    plan: 'Pro',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Cinematic XL',
      'Hardcore XL',
    ],
  },
  {
    title: 'Caught Naked Embarrassed',
    src: '/assets/loras/XLposes/Caught Naked Embarrased.webp',
    animeSrc: '/assets/loras/anime_caught_naked.webp',
    plan: 'Pro',
    categories: ['Straight', 'Lesbian'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Cinematic XL',
      'Hardcore XL',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'Caught Naked Embarrassed Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/Caught Naked Embarrassed Gay.webp',
    plan: 'Pro',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Gloryhole',
    src: '/assets/loras/real-gloryhole.webp',
    animeSrc: '/assets/loras/anime_gloryhole.webp',
    plan: 'Pro',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'Gloryhole Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Pro',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Man Grabbing Boobs',
    src: '/assets/loras/real-grabbing-boobs.webp',
    animeSrc: '/assets/loras/anime_man_grabbing_boob.webp',
    plan: 'Pro',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'Glory Wall',
    src: '/assets/loras/real-glory-wall.webp',
    animeSrc: '/assets/loras/anime_glorywall.webp',
    plan: 'Pro',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'Glory Wall Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Pro',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Wind Lift',
    src: '/assets/loras/XLposes/Wind_Lift.webp',
    animeSrc: '/assets/loras/anime_windlift.webp',
    plan: 'Pro',
    categories: ['Straight', 'Lesbian'],
    enabled: [
      'Cinematic XL',
      'Hardcore XL',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'POV Deepthroat',
    src: '/assets/loras/real-pov-deepthroat.webp',
    animeSrc: '/assets/loras/anime_deepthroat.webp',
    plan: 'Pro',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'POV Strangling',
    src: '/assets/loras/real-pov-strangling.webp',
    animeSrc: '/assets/loras/anime_strangling.webp',
    plan: 'Pro',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'POV Strangling Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Pro',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Licking Dick',
    src: '/assets/loras/XLposes/Licking_Dick.webp',
    animeSrc: '/assets/loras/anime_licking_dick.webp',
    plan: 'Pro',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Cinematic XL',
      'Hardcore XL',
      'Anime XL',
      'Real',
      'Anime',
      'Hyperreal',
      'Hyperanime',
      'Furtoon',
      'Fur',
      'K-Pop',
    ],
  },
  {
    title: 'Licking Dick Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/flame/Licking Dick Gay.webp',
    plan: 'Pro',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Reverse Sitting',
    plan: 'Pro',
    src: '/assets/loras/XLposes/Reverse_Sitting.webp',
    animeSrc: '/assets/loras/animepovdoggy-648a50b39754d.webp',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Cinematic XL',
      'Hardcore XL',
    ],
  },
  {
    title: 'Reverse Sitting Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Pro',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Girl Riding Guy',
    plan: 'Pro',
    src: '/assets/loras/XLposes/Girl_Ridding_Guy.webp',
    animeSrc: '/assets/loras/animepovdoggy-648a50b39754d.webp',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Cinematic XL',
      'Hardcore XL',
    ],
  },
  {
    title: 'Girl Riding Guy Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Pro',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Selfie',
    plan: 'Pro',
    src: '/assets/loras/XLposes/Selfie.webp',
    animeSrc: '/assets/loras/animepovdoggy-648a50b39754d.webp',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Cinematic XL',
      'Hardcore XL',
    ],
  },
  {
    title: 'Selfie Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/Selfie Gay.webp',
    plan: 'Pro',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Cinematic XL',
      'Hardcore XL',
    ],
  },
  {
    title: 'Creampie',
    plan: 'Pro',
    src: '/assets/loras/XLposes/Creampie.webp',
    animeSrc: '/assets/loras/animepovdoggy-648a50b39754d.webp',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Cinematic XL',
      'Hardcore XL',
    ],
  },
  {
    title: 'Creampie Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Pro',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Food Tease',
    plan: 'Pro',
    src: '/assets/loras/XLposes/Foodtease.webp',
    animeSrc: '/assets/loras/animepovdoggy-648a50b39754d.webp',
    categories: ['Straight'],
    enabled: ['Cinematic XL', 'Hardcore XL'],
  },
  {
    title: 'POV Man Masturbating',
    plan: 'Pro',
    src: '/assets/loras/XLposes/pov_masterbating.webp',
    animeSrc: '/assets/loras/animepovdoggy-648a50b39754d.webp',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Cinematic XL',
      'Hardcore XL',
    ],
  },
  {
    title: 'Girl POV',
    plan: 'Pro',
    src: '/assets/loras/XLposes/Girl_POV.webp',
    animeSrc: '/assets/loras/animepovdoggy-648a50b39754d.webp',
    categories: ['Straight'],
    enabled: ['Cinematic XL', 'Hardcore XL'],
  },
  {
    title: 'See Through Clothing',
    plan: 'Pro',
    src: '/assets/loras/XLposes/See_Through_CLothing.webp',
    animeSrc: '/assets/loras/animepovdoggy-648a50b39754d.webp',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Cinematic XL',
      'Hardcore XL',
    ],
  },
  {
    title: 'See Through Clothing Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/See Through Clothing Gay.webp',
    plan: 'Pro',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Cinematic XL',
      'Hardcore XL',
    ],
  },
  {
    title: 'Legs Behind Head',
    plan: 'Pro',
    src: '/assets/loras/XLposes/Legs_behind_head.webp',
    animeSrc: '/assets/loras/animepovdoggy-648a50b39754d.webp',
    categories: ['Straight'],
    enabled: ['Cinematic XL', 'Hardcore XL'],
  },
  {
    title: 'Doggystyle Front Angle',
    plan: 'Pro',
    src: '/assets/loras/XLposes/doggystyle_front_angle.webp',
    animeSrc: '/assets/loras/animepovdoggy-648a50b39754d.webp',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Cinematic XL',
      'Hardcore XL',
    ],
  },
  {
    title: 'Doggystyle Front Angle Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Pro',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Showing Feet',
    plan: 'Pro',
    src: '/assets/loras/XLposes/Showing_feet.webp',
    animeSrc: '/assets/loras/animepovdoggy-648a50b39754d.webp',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Cinematic XL',
      'Hardcore XL',
    ],
  },
  {
    title: 'Showing Feet Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/Showing Feet Gay.webp',
    plan: 'Pro',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Cinematic XL',
      'Hardcore XL',
    ],
  },
  {
    title: 'Carrying Sex',
    plan: 'Plus',
    src: '/assets/loras/XLposes/handjob.webp',
    animeSrc: '/assets/loras/animepovhj-648a50b397549.webp',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Carrying Sex Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Plus',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Breast Squeeze',
    plan: 'Free',
    src: '/assets/loras/pony/Breast Squeeze.webp',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Just Before Sex',
    plan: 'Free',
    src: '/assets/loras/pony/Just Before Sex.webp',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
    ],
  },
  {
    title: 'Just Before Sex Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Free',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Imminent Sex',
    plan: 'Free',
    src: '/assets/loras/pony/Imminent Sex.webp',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
    ],
  },
  {
    title: 'Imminent Sex Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Free',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Peace Sign',
    plan: 'Pro',
    src: '/assets/loras/pony/Peace Sign.webp',
    categories: ['Straight'],
    safe: true,
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Peace Sign Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Pro',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Tentacle',
    plan: 'Pro',
    src: '/assets/loras/pony/Tentacle.webp',
    animeSrc: '/assets/loras/ponyAnime/Tentacle.webp',
    categories: ['Straight', 'Lesbian'],
    hideToFree: true,
    hideToReviewer: true,
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
      'Anime XL',
    ],
  },
  {
    title: 'Tentacle Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Pro',
    categories: ['Gay'],
    hideToFree: true,
    hideToReviewer: true,
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Full Nelson',
    plan: 'Pro',
    src: '/assets/loras/pony/Full Nelson.webp',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
    ],
  },
  {
    title: 'Full Nelson Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Pro',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Prone Bone',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Pro',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Prone Bone Gay',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Pro',
    categories: ['Gay'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Prone Bone Lesbian',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    plan: 'Pro',
    categories: ['Lesbian'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Lesbian Kissing',
    plan: 'Pro',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    categories: ['Lesbian', 'Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Side View Anal Missionary',
    plan: 'Free',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
    ],
  },
  {
    title: 'Anime Boob Bounce',
    plan: 'Free',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    categories: ['Straight'],
    enabled: [
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Boob Bounce',
    plan: 'Free',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
    ],
  },
  {
    title: 'Walking Away',
    plan: 'Free',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
    ],
  },
  {
    title: 'Walking Towards',
    plan: 'Free',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Kissing',
    plan: 'Free',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/XLposes/POV_blowjob.webp',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Side View Blowjob',
    plan: 'Free',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/flame/Side View Blowjob.webp',
    categories: ['Straight'],
    enabled: ['Cinematic Flame'],
  },
  {
    title: 'Side View Doggystyle Anal',
    thumbFromSrc: true,
    plan: 'Free',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/flame/Side View Doggystyle Anal.webp',
    categories: ['Straight'],
    enabled: ['Cinematic Flame'],
  },
  {
    title: 'POV Anal Cowgirl',
    thumbFromSrc: true,
    plan: 'Free',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/flame/POV Anal Cowgirl.webp',
    categories: ['Straight'],
    enabled: ['Cinematic Flame'],
  },
  {
    title: 'BDSM Machine',
    thumbFromSrc: true,
    plan: 'Free',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/flame/BDSM Machine.webp',
    categories: ['Straight'],
    enabled: ['Cinematic Flame'],
  },
  {
    title: 'Giant Penis',
    thumbFromSrc: true,
    plan: 'Free',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/flame/Giant Penis.webp',
    categories: ['Gay'],
    enabled: ['Cinematic Flame'],
  },
  {
    title: 'Spy Camera',
    thumbFromSrc: true,
    plan: 'Free',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/flame/Spy Camera.webp',
    categories: ['Straight'],
    enabled: ['Cinematic Flame'],
  },
  {
    title: 'Hand on Hip',
    thumbFromSrc: true,
    plan: 'Free',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/flame/Hand on Hip.webp',
    categories: ['Straight'],
    enabled: ['Cinematic Flame'],
  },
  {
    title: 'Looking Back',
    thumbFromSrc: true,
    plan: 'Free',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/flame/Looking Back.webp',
    categories: ['Straight'],
    enabled: ['Cinematic Flame'],
  },
  {
    title: 'Walking',
    thumbFromSrc: true,
    plan: 'Free',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/flame/Walking.webp',
    categories: ['Straight'],
    enabled: ['Cinematic Flame'],
  },
  {
    title: 'Mirror Selfie',
    thumbFromSrc: true,
    plan: 'Free',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/flame/Mirror Selfie.webp',
    categories: ['Straight'],
    enabled: ['Cinematic Flame'],
  },
  {
    title: 'Touching Hair',
    thumbFromSrc: true,
    plan: 'Free',
    animeSrc: '/assets/loras/animepovbj-648a50b267536.webp',
    src: '/assets/loras/flame/Touching Hair.webp',
    categories: ['Straight'],
    enabled: ['Cinematic Flame'],
  },
  {
    title: 'Cowgirl Sideview',
    plan: 'Free',
    animeSrc: '/assets/loras/ponyAnime/Cowgirl Sideview.webp',
    src: '/assets/loras/pony/Cowgirl Sideview.webp',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Nipple Licking',
    plan: 'Free',
    animeSrc: '/assets/loras/ponyAnime/Nipple Licking.webp',
    categories: ['Straight'],
    enabled: [
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Nipple Licking Lesbian',
    thumbFromSrc: true,
    plan: 'Free',
    animeSrc: '/assets/loras/ponyAnime/Nipple Licking Lesbian.webp',
    categories: ['Lesbian'],
    enabled: [
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Nipple Licking Gay',
    thumbFromSrc: true,
    plan: 'Free',
    animeSrc: '/assets/loras/ponyAnime/Nipple Licking Gay.webp',
    categories: ['Gay'],
    enabled: [
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Cumshot on Tits',
    plan: 'Free',
    animeSrc: '/assets/loras/ponyAnime/Cumshot on Tits.webp',
    src: '/assets/loras/pony/Cumshot on Tits.webp',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Sixty-Nine',
    plan: 'Free',
    animeSrc: '/assets/loras/ponyAnime/Sixty-Nine.webp',
    categories: ['Straight'],
    enabled: [
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Double Penetration',
    plan: 'Free',
    src: '/assets/loras/pony/Double Penetration.webp',
    animeSrc: '/assets/loras/ponyAnime/Double Penetration.webp',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Squirting',
    plan: 'Free',
    src: '/assets/loras/pony/Squirting.webp',
    animeSrc: '/assets/loras/ponyAnime/Squirting.webp',
    categories: ['Straight'],
    enabled: [
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Reverse Footjob',
    plan: 'Free',
    src: '/assets/loras/pony/Reverse Footjob.webp',
    animeSrc: '/assets/loras/ponyAnime/Reverse Footjob.webp',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
    ],
  },
  {
    title: 'Throatfuck',
    plan: 'Free',
    src: '/assets/loras/pony/Throatfuck.webp',
    animeSrc: '/assets/loras/ponyAnime/Throatfuck.webp',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Lesbian Anal',
    plan: 'Free',
    src: '/assets/loras/ponyLesbian/Lesbian Anal.webp',
    animeSrc: '/assets/loras/ponyAnimeLesbian/Lesbian Anal.webp',
    categories: ['Lesbian'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Twerking',
    plan: 'Free',
    src: '/assets/loras/pony/Twerking.webp',
    animeSrc: '/assets/loras/ponyAnime/Twerking.webp',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Pile Driver',
    plan: 'Free',
    src: '/assets/loras/pony/Pile Driver.webp',
    animeSrc: '/assets/loras/ponyAnime/Pile Driver.webp',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Scissoring',
    plan: 'Free',
    src: '/assets/loras/pony/Scissoring.webp',
    animeSrc: '/assets/loras/ponyAnime/Scissoring.webp',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
    ],
  },
  {
    title: 'Spitroast',
    plan: 'Free',
    src: '/assets/loras/pony/Spitroast.webp',
    animeSrc: '/assets/loras/ponyAnime/Spitroast.webp',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Pullout Cumshot',
    plan: 'Free',
    src: '/assets/loras/pony/Pullout Cumshot.webp',
    animeSrc: '/assets/loras/ponyAnime/Pullout Cumshot.webp',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Kneeling Side',
    plan: 'Free',
    src: '/assets/loras/pony/Kneeling Side.webp',
    animeSrc: '/assets/loras/ponyAnime/Kneeling Side.webp',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Smoking',
    plan: 'Free',
    src: '/assets/loras/pony/Smoking.webp',
    animeSrc: '/assets/loras/ponyAnime/Smoking.webp',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Front Camera Selfie',
    plan: 'Free',
    src: '/assets/loras/pony/Front Camera Selfie.webp',
    animeSrc: '/assets/loras/ponyAnime/Front Camera Selfie.webp',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Sitting Straight',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Sitting Straight.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Sitting On Floor',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Sitting On Floor.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Cross-Legged',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Cross-Legged.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Sitting Sideways',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Sitting Sideways.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Sitting On Chair',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Sitting On Chair.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Sitting On Bed',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Sitting On Bed.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Sitting On Lap',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Sitting On Lap.webp',
    categories: ['Straight'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Seiza',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Seiza.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Lying On Back',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Lying On Back.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Lying On Side',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Lying On Side.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Lying On Bed',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Lying On Bed.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Lying On Floor',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Lying On Floor.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Standing On Tiptoes',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Standing On Tiptoes.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Standing With Arms Crossed',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Standing With Arms Crossed.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Standing Leaning',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Standing Leaning.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Standing Against Wall',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Standing Against Wall.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Standing With Legs Spread',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Standing With Legs Spread.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Crouching',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Crouching.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Running',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Running.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Jumping',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Jumping.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Mid-Air',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Mid-Air.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Dancing',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Dancing.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Twirling',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Twirling.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Stretching Arms Up',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Stretching Arms Up.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Stretching Legs Apart',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Stretching Legs Apart.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Sleeping',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Sleeping.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Sleeping On Side',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Sleeping On Side.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Reading',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Reading.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Using Phone',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Using Phone.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Cooking',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Cooking.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Face Touching',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Face Touching.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Lip Biting',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Lip Biting.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Tongue Out',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Tongue Out.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Wink',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Wink.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Lifting Skirt',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Lifting Skirt.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Lifting Dress',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Lifting Dress.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Adjusting Bra',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Adjusting Bra.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Sunbathing',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Sunbathing.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'In Pool',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/In Pool.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'At Beach',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/At Beach.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Standing Sex',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Standing Sex.webp',
    categories: ['Straight'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Against Wall',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Against Wall.webp',
    categories: ['Straight'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Ass Fingering',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Ass Fingering.webp',
    categories: ['Straight'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Anal Beads',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Anal Beads.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Pussy Licking',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Pussy Licking.webp',
    categories: ['Straight'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Side View Squirting',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Side View Squirting.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Camel Toe',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Camel Toe.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Breast Sucking',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Breast Sucking.webp',
    categories: ['Straight'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Underboob',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Underboob.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Spread Eagle',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Spread Eagle.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Blindfold',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Blindfold.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Sensory Deprivation',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Sensory Deprivation.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Upskirt',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Upskirt.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Skirt Lift',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Skirt Lift.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Pants Down',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Pants Down.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Underwear Only',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Underwear Only.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Orgasm',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/Orgasm.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'POV Under Table',
    plan: 'Free',
    src: '/assets/loras/ponyAnime/POV Under Table.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Anime Flame'],
  },
  {
    title: 'Futanari',
    plan: 'Free',
    src: '/assets/loras/pony/Futanari.webp',
    categories: ['Straight'],
    enabled: ['Cinematic Flame'],
  },
  {
    title: 'Restrained Sex',
    plan: 'Free',
    src: '/assets/loras/pony/Restrained Sex.webp',
    categories: ['Straight'],
    enabled: ['Cinematic Flame'],
  },
  {
    title: 'After Gangbang',
    plan: 'Free',
    src: '/assets/loras/pony/After Gangbang.webp',
    categories: ['Straight'],
    enabled: ['Cinematic Flame'],
  },
  {
    title: 'Riding Dildo From Behind',
    plan: 'Free',
    src: '/assets/loras/pony/Riding Dildo From Behind.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Cinematic Flame'],
  },
  {
    title: 'Cucumber Play',
    plan: 'Free',
    src: '/assets/loras/pony/Cucumber Play.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Cinematic Flame'],
  },
  {
    title: 'Kneeling Breast Grab',
    plan: 'Free',
    src: '/assets/loras/pony/Kneeling Breast Grab.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Cinematic Flame'],
  },
  {
    title: 'Two-Handed Blowjob',
    plan: 'Free',
    src: '/assets/loras/pony/Two-Handed Blowjob.webp',
    categories: ['Straight'],
    enabled: ['Cinematic Flame'],
  },
  {
    title: 'Sharing Penis',
    plan: 'Free',
    src: '/assets/loras/pony/Sharing Penis.webp',
    categories: ['Straight'],
    enabled: ['Cinematic Flame'],
  },
  {
    title: 'Blindfolded Squat',
    plan: 'Free',
    src: '/assets/loras/pony/Blindfolded Squat.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Cinematic Flame'],
  },
  {
    title: 'Gagged Shibari',
    plan: 'Free',
    src: '/assets/loras/pony/Gagged Shibari.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Cinematic Flame'],
  },
  {
    title: 'Head Grab Deepthroat',
    plan: 'Free',
    src: '/assets/loras/pony/Head Grab Deepthroat.webp',
    categories: ['Straight'],
    enabled: ['Cinematic Flame'],
  },
  {
    title: 'Girls Licking Pussy',
    plan: 'Free',
    src: '/assets/loras/pony/Girls Licking Pussy.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Cinematic Flame'],
  },
  {
    title: 'Masturbation With Clothes',
    plan: 'Free',
    src: '/assets/loras/pony/Masturbation With Clothes.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: ['Cinematic Flame'],
  },
  {
    title: 'Triple Penetration',
    plan: 'Free',
    src: '/assets/loras/pony/Triple Penetration.webp',
    categories: ['Straight'],
    enabled: ['Cinematic Flame'],
  },
  {
    title: 'Foursome',
    plan: 'Free',
    src: '/assets/loras/pony/Foursome.webp',
    categories: ['Straight'],
    enabled: ['Cinematic Flame'],
  },
  // Poses that also carry an LTX (video5) motion lora. They used to be video-only, reachable
  // through a bespoke picker; giving them an image prompt (see var/loras_data.py) makes them
  // ordinary poses — generate the image with the pose, animate it, and the video inherits the
  // pose off the image exactly like every other one.
  //
  // Enabled on Flame as well as XL / XL 2. Every model reads the backend's one pose table
  // (promptchan-backend var/loras_data.py): Flame uses a pose's `append_flame` when it has
  // one, else its `append_pony_xl`. (When Flame had its own backend with its own table, these
  // shipped in only one of the two, and on Flame the pose was silently absent from the image
  // while the LTX motion lora still loaded off it.) A Flame-only pose needs
  // `flame_only: True` there.
  {
    title: 'Belly Bulge',
    plan: 'Free',
    src: '/assets/loras/pony/Belly Bulge.webp',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Group Dance',
    plan: 'Free',
    src: '/assets/loras/pony/Group Dance.webp',
    categories: ['Straight', 'Lesbian'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Blowjob With Hands',
    plan: 'Free',
    src: '/assets/loras/pony/Blowjob With Hands.webp',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
  {
    title: 'Pussy Job',
    plan: 'Free',
    src: '/assets/loras/pony/Pussy Job.webp',
    categories: ['Straight'],
    enabled: [
      'Cinematic Flame',
      'Pony Photo XL 2',
      'Pony XL 2',
      'Pony Photo XL',
      'Pony XL',
      'Pony Illustration XL',
      'Pony Render XL',
      'Pony Anime XL',
      'Anime Flame',
    ],
  },
]
